// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"c241eae4","453":"89c0bd66","594":"a5e56138","660":"3ed01b46","821":"6ac073c0"}[chunkId] + ".chunk.js";
};